var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-width steps-indicator-container"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,class:{ 'step': true, 'completed': step <= _vm.currentStep}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }